module.exports = __webpack_public_path__ + "visceral-fat-mortality.c6588248986aa155e5fd2e82b2f122b8.png";